export default "__VITE_ASSET__Dqx7zqi6__"